// extracted by mini-css-extract-plugin
export default {"modal":"HdpeMxjgIL7yvHOXgARJ","warningCard":"KZzljqhe9BCPf6CQrohO"};